export const eventsMouse = {
	data() {
		return {
			mouseDownData: {
				clientX: 0,
				clientY: 0,
			},
			mouseMoveData: {
				element: null,
				actionMove: false,
				imageX: 0,
				imageY: 0,
			},
			mouseWatchElement: null,
            clickWatchElement: false,
		}
	},
	created() {
		window.addEventListener('mousedown', this.mouseDownClick);
		this.addMouseMoveElement = (element => {
			if (element !== null) {
				this.mouseMoveData.element = element;
				let elementRect = element.getBoundingClientRect();
				this.mouseMoveData.width = elementRect.width;
				this.mouseMoveData.height = elementRect.height;
				element.addEventListener('mousemove', this.mouseMoveEvent);
				element.addEventListener('mouseleave', this.mouseLeaveEvent);
			}
		});
		this.removeMouseMoveElement = (element => {
			if (element !== null) {
				element.removeEventListener('mousemove', this.mouseMoveEvent);
				element.removeEventListener('mouseleave', this.mouseLeaveEvent);
			}
		});
	},
	beforeUnmount() {
		window.removeEventListener('mousedown', this.mouseDownClick);
		if(this.mouseWatchElement !== null){
			this.removeMouseMoveElement(this.mouseMoveData.element);
		}
	},
	methods: {
		mouseDownClick(event) {
			this.mouseDownData.coordinateX = event.clientX;
			this.mouseDownData.coordinateY = event.clientY;
		},
		mouseMoveEvent(event) {
			this.mouseMoveData.actionMove = true;
			if(this.mouseMoveData.element !== null){
				const elementRect = this.mouseMoveData.element.getBoundingClientRect();
				const offsetX = event.clientX - elementRect.left;
				const offsetY = event.clientY - elementRect.top;
				this.mouseMoveData.imageX = (offsetX / elementRect.width) * 100;
				this.mouseMoveData.imageY = (offsetY / elementRect.height) * 100;
			}
		},
		mouseLeaveEvent(event) {
			this.mouseMoveData.actionMove = false;
		},
	},
}
